// src/components/Services.js
import React from 'react';
import '../styles/Services.css';
import van from '../assets/van.png';
import decoration from '../assets/decoration.png';
import rituals from '../assets/rituals.png';
import items from '../assets/items.png';

import registration from '../assets/registration.png';
import pandit from '../assets/pandith.png';
import freezer from '../assets/freezer.png';
import donation from '../assets/donation.png';

function Services() {
  return (
    <div className="services">
      <h2>Our Services</h2>
      <p className="intro-text">
        At Mahindra Funeral Services, we understand the importance of honoring your loved ones with dignity and respect.
        We offer comprehensive services to ensure a smooth and peaceful farewell.
      </p>

      <div className="service-cards">
        <div className="card">
          <img src={decoration} alt="Decoration" />
          <h4>Decoration</h4>
          <p>
            Creating a peaceful and serene environment for the ceremony with flowers, candles, and traditional elements.
          </p>
        </div>
        <div className="card">
          <img src={items} alt="Antyashti Samagri" />
          <h4>Antyashti Samagri</h4>
          <p>
            All necessary items for funeral rites are provided, ensuring families are not burdened with arrangements.
          </p>
        </div>
        <div className="card">
          <img src={van} alt="Vimukti Vahan" />
          <h4>Vimukti Vahan (Ambulance/Hearse)</h4>
          <p>
            Transporting the deceased from the hospital to home and later to the crematorium for final rites.
          </p>
        </div>
        <div className="card">
          <img src={rituals} alt="Sevak (Manpower)" />
          <h4>Sevak (Manpower)</h4>
          <p>
            Our team supports the family by managing all arrangements for the funeral rites.
          </p>
        </div>
        <div className="card">
          <img src={registration} alt="Registration & Death Certificate" />
          <h4>Registration & Death Certificate</h4>
          <p>
            Assistance with crematorium registration and acquiring the death certificate.
          </p>
        </div>
        <div className="card">
          <img src={pandit} alt="Bhataji/Pandit" />
          <h4>Bhataji/Pandit Services</h4>
          <p>
            Pooja and rituals performed as per caste traditions, including 10th, 12th, and 13th-day ceremonies.
          </p>
        </div>
      
        <div className="card">
          <img src={freezer} alt="Dead Body Freezer" />
          <h4>Dead Body Freezer & Embalming</h4>
          <p>
            Providing dead body freezers and embalming services for preservation until final rites.
          </p>
        </div>
        <div className="card">
          <img src={donation} alt="Organ Donation" />
          <h4>Co-ordination for Organ Donation</h4>
          <p>
            Facilitating organ, eye, and skin donation as part of our CSR initiative to fulfill the deceased’s final wish.
          </p>
        </div>
      </div>

      {/* <div className="additional-info">
        <h3>Why Choose Us?</h3>
        <p>
          We understand that every family is unique, and we offer personalized services to cater to different cultural and spiritual needs. Our dedicated team ensures that every aspect of the funeral service is handled with care, compassion, and respect.
        </p>
        <h4>Our Commitment:</h4>
        <ul>
          <li>24/7 Availability</li>
          <li>Respect for cultural traditions</li>
          <li>Trained and compassionate staff</li>
          <li>Affordable packages tailored to your needs</li>
        </ul>
      </div> */}
    </div>
  );
}

export default Services;